export default __webpack_public_path__ + "static/media/openHead.74117f5a.svg";